/**
 *
 * Toolbar
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Nav } from 'react-bootstrap';
import { navigate } from 'react-big-calendar/lib/utils/constants';
import { format, parseISO, SHORTDATE } from 'utils/date-fns/index.js';
import { dateString } from 'utils/timeFormat.js';
import StudentHeaders from './StudentHeaders.jsx';
import messages from './messages.js';

function Toolbar(props) {
  const { dates, students, onNavigate, date } = props;

  function navigateTo(toDate) {
    return () => onNavigate(navigate.DATE, new Date(toDate));
  }

  const activeKey = dateString(date);
  return (
    <>
      <Nav className="socs-tabs border-bottom mb-2" activeKey={activeKey}>
        {dates && dates.length > 0
          ? dates.map((d) => (
            <Nav.Item key={d}>
              <Nav.Link eventKey={d} onClick={navigateTo(d)}>
                {format(parseISO(d), SHORTDATE)}
              </Nav.Link>
            </Nav.Item>
          ))
          : <FormattedMessage {...messages.noSlots} />}
      </Nav>
      <StudentHeaders students={students} />
    </>
  );
}

Toolbar.propTypes = {
  dates: PropTypes.array,
  students: PropTypes.array,
  date: PropTypes.object,
  onNavigate: PropTypes.func,
};

export default Toolbar;
